import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getJobCardById, getSaleOrderByInsuranceId } from "../../actions/JobCardActions";
import { ThreeDots } from "react-loader-spinner";
import numberToWords from 'number-to-words';
import moment from "moment";

function TaxInvoice() {
    const dispatch = useDispatch();
    const params = useParams();

    const [editableJobCard, setEditableJobCard] = useState({});
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const jobCard = useSelector(state => state?.jobCard?.jobCard);
    const saleOrderInsurance = useSelector(state => state?.jobCard?.saleOrderInsurance);
    const loading = useSelector(state => state?.loading?.addEditLoading);
    const jobCardYear = jobCard?.created_at ? new Date(jobCard.created_at).getYear() % 100 : 0;
    const jobCardMonth = jobCard?.created_at ? new Date(jobCard.created_at).getMonth() + 1 : 0;
    const formattedJobCardId = jobCard?.job_card_id ? String(jobCard.job_card_id).padStart(6, '0') : 0;

    let lpoApproved = 0;

    if (jobCard?.lump_sum == 1) {
        lpoApproved = parseFloat(
            (
                parseFloat(editableJobCard?.lpo_claim?.lpo_value) || 0
            ) -
            (
                parseFloat(editableJobCard?.lpo_claim?.excess) || 0
            ) +
            (
                parseFloat(editableJobCard?.lpo_claim?.vat) || 0
            )
        );
    } else {
        lpoApproved = jobCard?.grand_total != null ? parseFloat(editableJobCard?.grand_total) : 0;
    }

    useEffect(() => {
        dispatch(getSaleOrderByInsuranceId(params.job_card_id));
        dispatch(getJobCardById(params.job_card_id));
    }, [params.job_card_id]);

    useEffect(() => {
        if (jobCard) {
            document.title = "ATA-" + jobCardYear + jobCardMonth + '-' + formattedJobCardId + "INV";
            setEditableJobCard(prevState => ({
                ...prevState,
                ...jobCard,
                show_spare_parts: true,
                show_repair_parts: true
            }));
        }
    }, [jobCard, jobCardYear, jobCardMonth, formattedJobCardId]);

    const amountToWords = (amount) => {
        const dollars = Math.floor(amount);
        const cents = Math.round((amount - dollars) * 100);

        const dollarsInWords = numberToWords.toWords(dollars);

        let centsInWords = '';
        if (cents > 0) {
            centsInWords = numberToWords.toWords(cents);
            centsInWords = `AND ${centsInWords.toUpperCase()} FILLS`;
        }

        return `${dollarsInWords.toUpperCase()} DHS ${centsInWords} ONLY/=`;
    };

    const amountInWords = lpoApproved && !isNaN(lpoApproved) && lpoApproved >= 0 ? amountToWords(lpoApproved) : null;

    const handleKeyDown = (event) => {
        if (event.key === 'F9') {
            setModalIsOpen(true);
        } else if (event.key === 'Escape') {
            setModalIsOpen(false);
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditableJobCard(prevState => {
            const newState = { ...prevState };
            const keys = name.split('.');
            let current = newState;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!current[keys[i]]) {
                    current[keys[i]] = {};
                }
                current = current[keys[i]];
            }
            current[keys[keys.length - 1]] = value;
            return { ...newState }; // Ensure a new object is returned
        });
    };

    return (
        <React.Fragment>
            <body className="bg-white w-full h-screen overflow-visible">
                <div className="intro-y bg-white pt-10">

                    <div className="border bg-white container border-gray-500 p-0">
                        <div className="text-center text-sm-start">
                            <img src="/images/logo.png" width={'100%'} height={100} alt="" />
                            <div className="row">
                                <div className="col-md-4 d-flex align-items-end px-5">
                                    <h3 className="fw-bold" style={{ float: 'left' }}>Job Id: {editableJobCard?.job_card_id}</h3>
                                </div>
                                <div className="col-md-4">
                                    <div className="bg-gray-300 ms-auto me-auto p-5">
                                        <div className="text-center text-decoration-underline text-uppercase fw-semibold fs-2xl">Tax Invoice</div>
                                        <div className="text-center mt-3 text-decoration-underline fw-semibold fs-2xl">فاتورة ضريبية</div>
                                    </div>
                                </div>
                                <div className="col-md-4">

                                </div>
                            </div>
                            {
                                loading ?
                                    <ThreeDots
                                        height="80"
                                        width="80"
                                        radius="9"
                                        color="#2d3748"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                        wrapperClassName=""
                                        visible={loading}
                                    /> :
                                    <span>
                                        <div className="row mt-3">
                                            <div className="col-md-4">
                                                <div className="row">
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Tel : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0">
                                                        <div className="p-1 pb-2 border border-gray-500">
                                                            <h3 className="fs-xs text-capitalize">00971 6 54 33 175</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Fax : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0">
                                                        <div className="p-1 pb-2 border border-gray-500">
                                                            <h3 className="fs-xs text-capitalize">00971 6 54 33 162</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Mobile : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0">
                                                        <div className="p-1 pb-2 border border-gray-500">
                                                            <h3 className="fs-xs text-capitalize">00971 50 888 5608</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5 pe-0 mb-2">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">P.O. Box : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0 mb-2">
                                                        <div className="p-1 pb-2 border border-gray-500">
                                                            <h3 className="fs-xs text-capitalize">33878 - SHARJAH</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Insurance : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12   ">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="fs-xs text-capitalize">{editableJobCard?.insurance_company?.name ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Ins. TRN# : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize fs-xs mb-1">{editableJobCard?.insurance_company?.vat ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="row">
                                                    <div className="col-md-12 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-uppercase fw-bold text-center text-decoration-underline">TRN# : 100225206000003</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-0">
                                                        <div className="border border-gray-500 py-2 px-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Invoice No : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="py-2 px-1 border border-gray-500">
                                                            <h3 className="text-capitalize fs-xs">{saleOrderInsurance && Object.keys(saleOrderInsurance).length > 0 ? saleOrderInsurance[0]['invoice_number'] : '-'}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 ps-0 mt-20">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Insurance Registered Address : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 ps-0 h-full">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize fs-xs">{editableJobCard?.insurance_company?.address ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="row">
                                                    <div className="col-md-6 p-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Date : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize fs-xs">{saleOrderInsurance && Object.keys(saleOrderInsurance).length > 0 ? new Date(saleOrderInsurance[0]['date']).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB')}</h3>
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize">{saleOrderInsurance && Object.keys(saleOrderInsurance).length > 0 ? saleOrderInsurance[0]['invoice_date'] : editableJobCard?.date}</h3>
                                                        </div>
                                                    </div> */}
                                                    <div className="col-md-6 p-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Customer : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize">{editableJobCard?.customer?.name ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 p-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Mobile : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize">{editableJobCard?.customer?.mobile ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 p-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Reg. No : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize">{editableJobCard?.estimate?.vehicle?.plate_number ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 p-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Type : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize">{editableJobCard?.estimate?.vehicle?.vehicle_type?.name ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 p-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Model : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize">{editableJobCard?.estimate?.vehicle?.vehicle_model?.name ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 p-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Make : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize">{editableJobCard?.estimate?.vehicle?.vehicle_make?.name ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 p-0">
                                                        <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                            <h3 className="fw-bold">Colour : </h3>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-0">
                                                        <div className="p-1 border border-gray-500">
                                                            <h3 className="text-capitalize">{editableJobCard?.estimate?.vehicle?.color?.name ?? '-'}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 mt-5">
                                                <table class="table table-print table-bordered">
                                                    <thead className="bg-gray-300 border border-gray-500">
                                                        <tr>
                                                            <th class="text-nowrap">Qty</th>
                                                            <th class="text-nowrap">Description</th>
                                                            <th class="text-nowrap">Rate</th>
                                                            <th class="text-nowrap">Vat @ 5%</th>
                                                            <th class="text-nowrap">Amount</th>
                                                        </tr>
                                                    </thead>
                                                    {
                                                        jobCard && editableJobCard?.lump_sum == "1" ?
                                                            <>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="fs-xs">1</td>
                                                                        <td className="fs-xs p-2">LUMP SUM WITH CLAIM NO : {editableJobCard?.lpo_claim?.lpo_no ?? '-'}</td>
                                                                        <td className="fs-xs">{parseFloat(editableJobCard?.lpo_claim?.lpo_value).toFixed(2) ?? '0'}</td>
                                                                        <td className="fs-xs">{editableJobCard?.lpo_claim?.vat ? parseFloat(editableJobCard?.lpo_claim?.vat).toFixed(2) : '0'}</td>
                                                                        <td className="fs-xs">{parseFloat(parseFloat(editableJobCard?.lpo_claim?.lpo_value) + parseFloat(editableJobCard?.lpo_claim?.vat)).toFixed(2) ?? '0'}</td>
                                                                    </tr>
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <td className="fs-xs text-end" colSpan={'4'}>Pre-Tax :</td>
                                                                        <td className="fs-xs">{editableJobCard?.lpo_claim?.lpo_value ? parseFloat(editableJobCard?.lpo_claim?.lpo_value).toFixed(2) : '0'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fs-xs text-end" colSpan={'4'}>Excess (-) :</td>
                                                                        <td className="fs-xs">{editableJobCard?.lpo_claim?.excess ? parseFloat(editableJobCard?.lpo_claim?.excess).toFixed(2) : '0'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fs-xs text-end" colSpan={'4'}>Taxable:</td>
                                                                        <td className="fs-xs">{editableJobCard?.lpo_claim?.Excess ? parseFloat(parseFloat(editableJobCard?.lpo_claim?.lpo_value) - parseFloat(editableJobCard?.lpo_claim?.excess) ?? 0).toFixed(2) : '0'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fs-xs text-end" colSpan={'4'}>Vat @ 5% :</td>
                                                                        <td className="fs-xs">{editableJobCard?.lpo_claim?.vat ? parseFloat(editableJobCard?.lpo_claim?.vat).toFixed(2) : '0'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fs-xs fw-bold text-end" colSpan={'4'}>Total :</td>
                                                                        <td className="fs-xs">{
                                                                            parseFloat(
                                                                                (
                                                                                    parseFloat(editableJobCard?.lpo_claim?.lpo_value) || 0
                                                                                ) -
                                                                                (
                                                                                    parseFloat(editableJobCard?.lpo_claim?.excess) || 0
                                                                                ) +
                                                                                (
                                                                                    parseFloat(editableJobCard?.lpo_claim?.vat) || 0
                                                                                )
                                                                            ).toFixed(2)
                                                                            ?? '0'
                                                                        }
                                                                        </td>
                                                                    </tr>
                                                                </tfoot>
                                                            </>
                                                            :
                                                            <>
                                                                <tbody>
                                                                    {
                                                                        editableJobCard?.job_card_details && Object.keys(editableJobCard?.job_card_details).length > 0 &&
                                                                        editableJobCard?.job_card_details.map((detail, index) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td className="fs-xs">{detail?.quantity}</td>
                                                                                    <td className="fs-xs p-2">{detail?.product_name}</td>
                                                                                    <td className="fs-xs">{detail?.price_sold ? parseFloat(detail?.price_sold).toFixed(2) : '0'}</td>
                                                                                    <td className="fs-xs">{detail?.vat_amount ? parseFloat(detail?.vat_amount).toFixed(2) : '0'}</td>
                                                                                    <td className="fs-xs">{detail?.total_amount ? parseFloat(detail?.total_amount).toFixed(2) : '0'}</td>
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <td className="fs-xs text-end" colSpan={'4'}>Excess (-) :</td>
                                                                        <td className="fs-xs">{editableJobCard?.lpo_claim?.excess ? parseFloat(editableJobCard?.lpo_claim?.excess).toFixed(2) : '0'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fs-xs text-end" colSpan={'4'}>Sub-Total :</td>
                                                                        <td className="fs-xs">{editableJobCard?.total_amount ? parseFloat(editableJobCard?.total_amount).toFixed(2) : '0'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fs-xs text-end" colSpan={'4'}>Vat @ 5% :</td>
                                                                        <td className="fs-xs">{editableJobCard?.vat_amount ? parseFloat(editableJobCard?.vat_amount).toFixed(2) : '0'}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fs-xs fw-bold text-end" colSpan={'4'}>Total :</td>
                                                                        <td className="fs-xs">{editableJobCard?.grand_total ? parseFloat(parseFloat(editableJobCard?.grand_total)).toFixed(2) : '0'}</td>
                                                                    </tr>
                                                                </tfoot>
                                                            </>
                                                    }

                                                </table>
                                            </div>
                                            <div className="col-md-12 mt-10">
                                                <div className="border border-gray-500 p-1 bg-gray-300 h-full text-center">
                                                    {/* <h3 className="fw-bold">{amountInWords}</h3> */}
                                                </div>
                                            </div>
                                            <div className="col-md-4 p-5">
                                                <div className="row">
                                                    {
                                                        editableJobCard?.images &&
                                                        editableJobCard?.images
                                                            .filter((image) => image.type === 'jobIn')
                                                            .slice(0, 6)
                                                            .map((image) => (
                                                                <div className="col-sm-4" key={image.file_name}>
                                                                    <img className="w-full my-2 h-12" src={`${image.image_path}/${image.file_name}`} alt="" />
                                                                </div>
                                                            ))
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-4 p-5">
                                                <div className="row">
                                                    {
                                                        editableJobCard?.images &&
                                                        editableJobCard?.images
                                                            .filter((image) => image.type === 'jobOut')
                                                            .slice(0, 6)
                                                            .map((image) => (
                                                                <div className="col-sm-4" key={image.file_name}>
                                                                    <img className="w-full my-2 h-12" src={`${image.image_path}/${image.file_name}`} alt="" />
                                                                </div>
                                                            ))
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-4 p-5">
                                                <p className="fs-xs">
                                                    MAKE ALL CHEQUES PAYABLE TO: <br />
                                                    Al-Tharaa Auto Workshop L.L.C. <br />
                                                    Attn: Hassan Ashraf Butt <br />
                                                    P.O.Box No.: 33878 - Sharjah <br />
                                                    United Arab Emirates.
                                                </p>
                                            </div>
                                            <div className="col-md-12 mb-5">
                                                <div className="border border-gray-500 p-1 bg-gray-300 h-full text-center">
                                                    <h3 className="fw-bold">THANK YOU FOR YOUR BUSINESS !</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                            }
                        </div>
                    </div>
                </div>
            </body >

            <div className={`modal fade  ${modalIsOpen ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ display: modalIsOpen ? 'block' : 'none', border: '1px solid black' }}>
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Job Card</h5>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Name:</label>
                                            <input type="text" className="form-control" name="insurance_company.name" value={editableJobCard?.insurance_company?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Mobile:</label>
                                            <input type="text" className="form-control" name="insurance_company.vat" value={editableJobCard?.insurance_company?.vat ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Registration Expiry:</label>
                                            <input type="date" className="form-control" name="estimate.vehicle.registration_expiry" value={editableJobCard?.estimate?.vehicle?.registration_expiry ? moment(editableJobCard.estimate.vehicle.registration_expiry).format('YYYY-MM-DD') : ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Reference:</label>
                                            <input type="text" className="form-control" name="insurance_company.address" value={editableJobCard?.insurance_company?.address ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Customer Name:</label>
                                            <input type="text" className="form-control" name="customer.name" value={editableJobCard?.customer?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Customer Name:</label>
                                            <input type="text" className="form-control" name="customer.mobile" value={editableJobCard?.customer?.mobile ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Model:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.vehicle_model.name" value={editableJobCard?.estimate?.vehicle?.vehicle_model?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Plate Number:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.plate_number" value={editableJobCard?.estimate?.vehicle?.plate_number ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Code:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.vehicle_code.name" value={editableJobCard?.estimate?.vehicle?.vehicle_code?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>State:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.state.name" value={editableJobCard?.estimate?.vehicle?.state?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Type:</label>
                                            <input type="text" className="form-control" name="estimate.type_id" value={editableJobCard?.estimate?.type_id === 1 ? 'Private' :
                                                editableJobCard?.estimate?.type_id === 2 ? 'Insurance' :
                                                    editableJobCard?.estimate?.type_id === 3 ? 'N/A' : ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Chasis No:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.chasis_no" value={editableJobCard?.estimate?.vehicle?.chasis_no ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Type:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.vehicle_type.name" value={editableJobCard?.estimate?.vehicle?.vehicle_type?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Make:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.vehicle_make.name" value={editableJobCard?.estimate?.vehicle?.vehicle_make?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Color:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.color.name" value={editableJobCard?.estimate?.vehicle?.color?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setModalIsOpen(false)}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}

export default TaxInvoice;